module.exports = __webpack_public_path__ + "static/media/RegenciaAmbiental.a9618cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/RegenciaAmbiental.png
// module id = 110
// module chunks = 0